import Call from '../Call.v2';

const BidderFeeds = {
    get() {
        return Call(`bidder/feeds`);
    },
};

export default BidderFeeds;



// WEBPACK FOOTER //
// ./src/services/API/components/BidderFeeds.js